import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSettingsGear2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconSettingsGear2"><Path d="M9.15 5.35L6.0625 4.6375L4.6375 6.0625L5.35 9.15L2.5 11.05V12.95L5.35 14.85L4.6375 17.9375L6.0625 19.3625L9.15 18.65L11.05 21.5H12.95L14.85 18.65L17.9375 19.3625L19.3625 17.9375L18.65 14.85L21.5 12.95V11.05L18.65 9.15L19.3625 6.0625L17.9375 4.6375L14.85 5.35L12.95 2.5H11.05L9.15 5.35Z" stroke="currentColor"/><Path d="M15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconSettingsGear2;
